import React from 'react';

interface ModelLogoProps {
  src?: string;
  alt: string;
  sizeClass?: string;
  fallback?: React.ReactNode;
}

const ModelLogo: React.FC<ModelLogoProps> = ({
  src,
  alt,
  sizeClass = 'h-9 w-9',
  fallback,
}) => {
  if (src) {
    return (
      <div className={`${sizeClass} shrink-0 flex items-center justify-center`}>
        <img src={src} alt={alt} className="h-full w-full object-contain" />
      </div>
    );
  }

  return (
    <div className={`${sizeClass} shrink-0 flex items-center justify-center text-muted-foreground`}>
      {fallback}
    </div>
  );
};

export default ModelLogo;
